<template>
<div class="container-box">
    <div :id="id" :style="{height:height,width:width}"></div>
    <div v-if="showMonth" class="id-btn" @click="ChangeToyear(dateYearNow,currentIndex)">切换到年</div>
    <div v-if="!showMonth&&type=='user'" class="id-btn">
        <span>{{dateYearNow}}年</span>
        <span :class="(currentIndex==0?'':'btn-active ')+'iconfont iconxiangshang btn-up'" @click="changeDate(1,currentIndex==0?false:true,dateYearNow,currentIndex)"></span>
        <span :class="(currentIndex==2?'':'btn-active ')+'iconfont iconxiangxia btn-down'" @click="changeDate(2,currentIndex==2?false:true,dateYearNow,currentIndex)"></span>
    </div>
</div>
</template>

<script>
import echarts from 'echarts';
export default {
    props: ['className', 'id', 'height', 'width', 'type', 'echartsData', 'dateYearNow', 'currentIndex', 'showMonth'],
    data() {
        return {}
    },
    mounted() {
        if (this.type == 'user') {
            let result1 = []; //注册用户
            let result2 = []; //新增用户
            this.echartsData.map(item => {
                if (item.key == 'register') {
                    result1 = item.data;
                } else {
                    result2 = item.data
                }
            })
            let dataAxis = result1.map(item => {
                return {
					value: item.monthOrDay,
					textStyle: {
						color: '#04C3F1'
					}
				}
            })
            let data = result1.map(item => {
                return {
                    value: item.data.reduce((pre, cur) => {
                        return pre + cur.num
                    }, 0),
                    data: item.data,
                    date: item.monthOrDay
                };
            })
            let data2 = result2.map(item => {
                return {
                    value: item.data.reduce((pre, cur) => {
                        return pre + cur.num
                    }, 0),
                    data: item.data,
                    date: item.monthOrDay
                };
            })
            let series = [{
                name: '活跃用户',
                data: data2,
                type: 'line',
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color: 'rgba(4, 195, 241, .4)'
                },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(
                        0, 1, 0, 0,
                        [{
                                offset: 0,
                                color: 'transparent'
                            },
                            {
                                offset: 1,
                                color: '#04C3F1'
                            }
                        ]
                    )
                }
            }, {
                name: '新增用户',
                data: data,
                type: 'line',
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color: 'rgba(4,238,244,.4)'
                },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(
                        0, 1, 0, 0,
                        [{
                                offset: 0,
                                color: 'transparent'
                            },
                            {
                                offset: 1,
                                color: '#04EEF4'
                            }
                        ]
                    )
                }
            }];
            this.changeLine(dataAxis, series);
        } else if (this.type == 'alarm' || this.type == 'camera') {
            let result1 = this.echartsData;
            let dataAxis = result1.map(item => {
                return {
					value: item.monthOrDay,
					textStyle: {
						color: '#04EEF4'
					}
				}
            })
            let data = result1.map(item => {
                return {
                    value: item.totalNum,
                    data: item.data,
                    date: item.monthOrDay
                };
            })
            let series = [{
                data: data,
                type: 'line',
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color: 'transparent'
                },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(
                        0, 1, 0, 0,
                        [{
                                offset: 0,
                                color: 'transparent'
                            },
                            {
                                offset: 1,
                                color: 'rgba(4, 238, 244, .6)'
                            }
                        ]
                    )
                }
            }];
            this.changeLine(dataAxis, series);
        }
    },
    beforeDestroy() {

    },
    methods: {
        changeLine(dataAxis, series) {
            const that = this;
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById(this.id));
            // 绘制图表
            myChart.setOption({
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: dataAxis,
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#fff'
                    },
                    axisPointer: {
                        show: true
                    }
                },
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '5%',
                    top: '10%',
                    containLabel: true
                },
                yAxis: {
                    type: 'value',
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (datas) {
                        if (that.type == 'alarm' || that.type == 'camera') {
                            var res = datas[0].data.date + '<br/>',
                                val;
                            for (var i = 0, length = datas[0].data.data.length; i < length; i++) {
                                val = (datas[0].data.data[i].num);
                                res += datas[0].data.data[i].type + '：' + val + '<br/>';
                            }
                            return res;
                        } else {
                            var res = datas[0].axisValue + '<br/>',
                                val;
                            datas.map(item => {
                                res += item.seriesName + '<br/>';
                                item.data.data.map(citem => {
                                    res += citem.type + ':' + (citem.num ? citem.num : '0') + '<br/>'
                                })
                            })
                            return res;
                        }
                    },
                    position: ['10px', '10px']
                },
                dataZoom: [{
                    type: 'inside',
                    zoomOnMouseWheel: false,
                    moveOnMouseWheel: false,
                    startValue: 0,
                    endValue: 11
                }],
                series: series
            })
            if (!this.showMonth) {
                myChart.on('click', function (e) {
                    that.$emit('DateClick', {
                        month: e.name,
                        showMonth: true
                    })
                })
            }
        },
        changeDate(type, canClick, dateYearNow, currentIndex) {
            if (canClick) {
                if (type == 1) { //上
                    this.$emit('monthClick', {
                        year: dateYearNow - 1,
                        index: currentIndex - 1,
                        showMonth: false
                    })
                } else { //下
                    this.$emit('monthClick', {
                        year: dateYearNow + 1,
                        index: currentIndex + 1,
                        showMonth: false
                    })
                }
            }
        },
        ChangeToyear(dateYearNow, currentIndex) {
            this.$emit('monthClick', {
                year: dateYearNow,
                index: currentIndex,
                showMonth: false
            })
        }
    }
}
</script>

<style lang="less" scoped>
.id-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    padding: 5px 30px 5px 20px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    background: url(../../../assets/images/cloud/activeBtn.png);
    background-size: 100% 100%;
    box-sizing: border-box;

    .btn-up {
        position: absolute;
        right: 10px;
        top: 4px;
        font-size: 12px;
    }

    .btn-down {
        position: absolute;
        right: 10px;
        bottom: 4px;
        font-size: 12px;
    }

    .btn-active {
        color: #04C3F1;
    }
}
</style>
